import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(theme => ({
    dialogContent: {
        flex: "1",
        // padding: "20px 10px 10px",
        backgroundColor: "#FFFFFF",
        minWidth: window.isMobileView ? '100%': '850px',
        maxWidth: window.isMobileView ? '100%': '850px',
    },
    dialogPaper: {
        minWidth: window.isMobileView ? '95%': "800px"
    },
    box: {
        display: "flex",
        flexFlow: "column",
        height: "100%",
        // padding: "18px 10px 10px 20px",
        padding: '0px 0px 0px 0px'
    },
    header: {
        flex: "0 1 auto",
        display: "flex",
        padding: '15px 10px',
        alignItems: 'baseline',
        cursor: 'move',
        backgroundColor: "#0049A3",
        justifyContent: 'space-between'
    },
    content: {
        flex: "1 1 auto",
        // maxHeight: "580px",
        // overflow: "auto",
        marginBottom: "10px",
        padding: '10px 20px'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '10px',
        justifyContent: 'space-between',
        borderBottom: '1px solid #F1F1F1',
        backgroundColor: "#DFEEFF",
        padding: '0 10px'
    },
    shippingLayout: {
        "& .custom-label": {
           // marginTop: '10px !important',
        }
        
    },
    marginTopTwenty: {
        marginTop: '25px',
    },
    cardHeaderTitle: {
        display: "flex",
        alignItems: "center"
    },
    container: {
        paddingRight: '25px'
    },
    footer: {
        flex: "0 1 40px",
        gap: '10px',
        padding: '15px 20px',
        background: '#F8F9FB',
    },
    footerRight: {
        float: "right",
        marginRight: "-8px",
        display: 'flex',
        gap: '10px'
    },
    notesEditor: {
        "& .RichTextEditor__root___2QXK-": {
            minHeight: '160px',
            maxHeight: '160px',
            overflow: 'auto',
        }
    },
    crossButton: {
        position: "relative",
        top: "-12px",
        right: "10px",
        cursor: "pointer",
        padding: "3px",
        zIndex: "2",
        display: "block",
        "& :hover": {
            backgroundColor: "#F4F4F4",
        }
    },
    closeIcon: {
        cursor: 'pointer',
        color: 'white',
    },
    title: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '20px',
        lineHeight: '24px',
        color: '#FFFFFF',
        letterSpacing: '0.02em',
    },
    labelText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize:window.isMobileView?  window.isMobile425 ? '12px':'14px':'16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "14px 0px 5px",
    },
    valueText: {
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '20px',
        color: '#3C4549',
        padding: "6px 0",
        textTransform: 'capitalize',
    },
    backBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
        lineHeight: '16px',
        fontWeight: 600,
        color: '#0049A3',
        borderRadius: '4px',
        padding: window.isMobileView? window.isMobile425 ? '4px 8px':'6px 12px':'8px 16px',
        textTransform: 'capitalize',
        border: '1px solid #0049A3',
        cursor: 'pointer',
    },
    changeBtn: {
        fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',

        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    secHeading: {
        color: '#4F4F4F',
        fontSize: '16px',
        lineHeight: '12px',
        padding: '12px 6px',
        borderBottom: '1px solid #BBBEBF',
        width: '100%',
        marginBottom: '15px',
        fontFamily: 'Lato',
        fontWeight: 600,
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 12px',
        height: '35.63px',
        opacity: '0.7',
        border: '0.5px solid #777D80',
        borderRadius: '4px',

      
    
        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 12px",
            minHeight: "35.63px",
            fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
            color: "#4A4A4A",
            '&:focus': {
              background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },
    trHeader: {
        height: '40px',
        display: 'flex',

        justifyContent: 'space-between',
        backgroundColor: '#CEDDFF',
    },
    trHeaderLabel: {
        color: 'black',
        fontSize:window.isMobileView?  window.isMobile425 ? '12px !important':'14px !important': '16px !important',
        fontFamily: 'Lato',
        fontWeight: 'bold',
        marginTop: '0px',


    }, gridRow: {

        border: '0.5px darkcyan',
        borderTop: '0.5px solid',
        fontFamily: 'Lato',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        letterSpacing: '0.01em',
        borderTop: '1px solid #E1E1E1',
        textAlign: 'left',
        paddingLeft: '15px',
    },

    gridRowBottom: {
        borderBottom: '1px solid #E1E1E1',
        padding: "0px 12px",

    },

    gridRowBottomLeft: {
        borderBottom: '1px solid #E1E1E1',
        borderLeft: '1px solid #E1E1E1',
        padding: "0px 12px",
    },
    gridRowBottomRight: {
        borderBottom: '1px solid #E1E1E1',
        borderRight: '1px solid #E1E1E1',
        padding: "0px 12px",
    },
    griLabel: {
        color: '#6E6E6E',
        fontWeight:'bold'
    },
    griLabelChild: {
        color: '#6E6E6E',
        paddingLeft: "30px",
        fontSize: window.isMobileView ? '14px': 'initial',
        lineHeight: window.isMobileView ? '21px': 'normal',
    },
    gridFirstColumn: {
        backgroundColor: '#E8E8E8',
    },
    paper: {
        borderRadius: '15px',
        background: '#FFFFFF',
        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        margin: '0px 10px',
        marginBottom: '20px',
        minHeight: '320px',
    },
    paymentPaper: {
        borderRadius: '15px',
        background: '#FFFFFF',
        boxShadow: '0px 6px 24px rgba(0, 0, 0, 0.2)',
        position: 'relative',
        margin: '0px 10px',
        marginBottom: '20px',
    },
    paperTop: {
        display: 'flex',
        alignItems: 'baseline',
        background: '#CEDDFF',
        padding: '15px 0px',
    },
    paperHeading: {
        fontSize: window.max1550 ? '19px' : '24px',
        lineHeight: '29px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        color: '#41416E',
        fontWeight: '700',
        margin: 0,
    },
    linkClick: {
        cursor: 'pointer',
    },
    paperBottom: {
        padding: '15px 15px',
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 12px',
        height: '35.63px',
        opacity: '0.7',
        border: '0.5px solid #777D80',
        borderRadius: '4px',



        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 12px",
            minHeight: "35.63px",
            fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
            color: "#4A4A4A",
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    }
}));